import React, { Component } from 'react';
import {formDataSchema} from '../../../schema/bill-tacking';
import Select2 from '../../../components/FormComponent/select2';
import Inputlayer from '../../../components/FormComponent/Input';
import { filter, formData, dissableFormData } from '../../../schema/apppointment';

class Report_Finanical_Counselling extends Component {
    render() {
        return (
            <div>
                <div className="card m-5 card-table">
                    <div className="card-header bg8">
                      <div className="clearfix">
                            <div className="float-left pt-1">
                            Financial Counselling   
                            </div>
                            <div className=" row col-xl-8 float-right">
                                {formDataSchema.feilds
                                    .map((feild, key) => {

                                        if (feild.element === 'input') {
                                            return (

                                                <div
                                                    className={`${feild.className
                                                        ? feild.className
                                                        : 'col'} ${feild.name}`}
                                                    key={key}>                                                        
                                                    <Inputlayer
                                                        {...this.props}
                                                        {...this.state}
                                                        feildData={feild}
                                                    />
                                                </div>

                                            )
                                        }
                                        if (feild.element === 'select2') {
                                            return (
                                                <React.Fragment key={key}>
                                                    {(feild.name === 'patient_list' && feild.disable === false) &&
                                                        <div className="col-6">
                                                            <p className="mb-0 text-black pl-0" style={{ fontSize: 13 + 'px', lineHeight: 2, backgroundColor: 'transparent' }}><span className="text-info" style={{ fontSize: 15 + 'px', lineHeight: 2 }}>Note:</span> Please Select Patient List</p>
                                                        </div>}
                                                    <div
                                                        className={`${feild.className
                                                            ? feild.className
                                                            : 'col '} ${feild.name}`}
                                                        key={key}>
                                                        <p className="data-label text-white w-75 mb-1 pt-1 text-right pr-2">{feild.text2}</p>
                                                        <Select2
                                                            Queuedata={formData}
                                                            selectdata={feild}
                                                            {...this.props}
                                                            {...this.state}
                                                        /> {feild
                                                            .errors
                                                            .map((error, eKey) => {
                                                                return (
                                                                    <small key={eKey} className="form-text text-danger">{error.message}</small>
                                                                );
                                                            })}
                                                    </div>
                                                </React.Fragment>
                                            )
                                        }
                                    })}
                            </div>
                        </div>                                     
                    </div>
                  <div className="financial-table table-responsive">                 
                        <table className="table table-hover table-bordered mb-0">
                            <thead>
                                <tr>

                                    <td>S.no</td>
                                    <td>FC Number</td>
                                    <td>IP Number</td>
                                    <td>UMR Number</td>
                                    <td>Patient Name</td>
                                    <td>Phone Number</td>
                                    <td>Date</td>
                                    <td>Status</td>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>

                                    <td>01</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr>

                                    <td>02</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr className="accordion-toggle collapsed" id="accordion2" data-toggle="collapse" data-parent="#accordion2" href="#collapseTwo">
                                    <td class="expand-button">03</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr className="hide-table-padding collapse in" id="collapseTwo">
                                    <td >a</td>
                                    <td >FC124587</td>
                                    <td >IP125789643</td>
                                    <td >UMR124578965</td>
                                    <td >Jeet Singh Rajpoot</td>
                                    <td >9876543210</td>
                                    <td >7-3-2020</td>
                                    <td >Active</td>
                                </tr>
                                <tr className="hide-table-padding collapse in" id="collapseTwo">
                                    <td >a</td>
                                    <td >FC124587</td>
                                    <td >IP125789643</td>
                                    <td >UMR124578965</td>
                                    <td >Jeet Singh Rajpoot</td>
                                    <td >9876543210</td>
                                    <td >7-3-2020</td>
                                    <td >Active</td>
                                </tr>
                                <tr>

                                    <td>04</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr>

                                    <td>05</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr className="accordion-toggle collapsed" id="accordion2" data-toggle="collapse" data-parent="#accordion2" href="#collapseThree">
                                    <td className="expand-button">06</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr className="hide-table-padding collapse in" id="collapseThree">
                                    <td >a</td>
                                    <td >FC124587</td>
                                    <td >IP125789643</td>
                                    <td >UMR124578965</td>
                                    <td >Jeet Singh Rajpoot</td>
                                    <td >9876543210</td>
                                    <td >7-3-2020</td>
                                    <td >Active</td>
                                </tr>
                                <tr className="hide-table-padding collapse in" id="collapseThree">
                                    <td >a</td>
                                    <td >FC124587</td>
                                    <td >IP125789643</td>
                                    <td >UMR124578965</td>
                                    <td >Jeet Singh Rajpoot</td>
                                    <td >9876543210</td>
                                    <td >7-3-2020</td>
                                    <td >Active</td>
                                </tr>
                                <tr>

                                    <td>07</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr>

                                    <td>08</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr>

                                    <td>09</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                                <tr>

                                    <td>10</td>
                                    <td>FC124587</td>
                                    <td>IP125789643</td>
                                    <td>UMR124578965</td>
                                    <td>Jeet Singh Rajpoot</td>
                                    <td>9876543210</td>
                                    <td>7-3-2020</td>
                                    <td>Active</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>               
            </div>
        )
    }
}

export default Report_Finanical_Counselling;